import { BaseAPI } from './BaseAPI.js'
import { AsteriskSound } from '../types/index.js'

export default class AsteriskSoundsAPI extends BaseAPI<AsteriskSound> {
  override get resource(): string {
    return '/asteriskSounds'
  }
}
